// Solve Engineering Solutions — the FRONTEND face of the client config seam.
// The '@client/config' vite alias resolves here in this fork (web/vite.config.js
// repoint — the fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'Solve Engineering Solutions';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Solve Engineering Solutions — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

export const WORKSPACES_ENABLED = false;

export const STORAGE_PREFIX = 'solve-engineering-solutions';

export const PROJECT_ISSUE_TYPE = '01 - Project';
export const MODULE_ISSUE_TYPE = '02 - Module';
export const LINK_TYPE_NAME = 'Parent - Child';

export const WPO_FIELD = 'customfield_10036';

export const ACCENT_RGB = { r: 238, g: 72, b: 54 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// Solve's own views of fields on the work item screen — the product's FIELD_VIEWS seam (work-items
// FieldView). Loaded through the '@client/customs' alias, never a relative path: web/vite.config.js
// reads this file and Vite bundles its config, so a relative import would break the build.
// (Frontend only: the server face has no views.)
//   SW Warehouse Panel   on every Solve Warehouse (SW) work item: what the warehouse did with it, live
//                        (a stock item's card; a request's / order's / book back's lines and what each
//                        button will do) — warehouse/views/Panel.jsx. The field holds nothing.
//   SW Job Item          the job's work item a stock request or book back is for: found by key, Summary
//                        or project, shown as a card with its SJ Number — warehouse/views/JobItem.jsx
//   SW Stock Requests    on the JOB's own work item (Fabrication / Integration Sub-Task, Supply Chain):
//                        its stock requests and book backs, live, and "Request stock" — views/JobStock.jsx
//   CUSTOMER             on a Customer (CDS) work item: the customer's whole story, the CRM way — who
//                        they are, pipeline, won, every opportunity, the timeline — and the contact
//                        details edited right there — crm/parts/CustomerField.jsx. The field holds nothing.
export const FIELD_VIEWS = [
  { field: 'SW Warehouse Panel', label: 'Solve Warehouse', collapsible: true, load: () => import('@client/customs/warehouse/views/Panel.jsx') },
  { field: 'SW Job Item', label: 'Job (SW Job Item)', load: () => import('@client/customs/warehouse/views/JobItem.jsx') },
  { field: 'SW Stock Requests', label: 'Stock (Solve Warehouse)', collapsible: true, load: () => import('@client/customs/warehouse/views/JobStock.jsx') },
  { field: 'CUSTOMER', label: 'Customer', load: () => import('@client/customs/crm/parts/CustomerField.jsx') },
  { field: 'LOCATION', label: 'Location', load: () => import('@client/customs/crm/parts/LocationField.jsx') },
  // Create from SJ Catalogue (SOLVE Catalogue, catalogue/DESIGN.md): on the "01 - Project" work item — pick a historic SJ, see
  // the whole tree it makes, choose the fields to clear, sign off, Create: the job copied at every level as the next
  // SJ — catalogue/sjcopy/CreateFromSjField.jsx. The field's value is the line the server writes after a copy.
  // Called "Create from SJ" until 2026-10-29: a site whose field still has that name draws the same view (under the
  // new label) until Catalogue → Setup renames it.
  { field: 'Create from SJ Catalogue', label: 'Create from SJ Catalogue', collapsible: true, load: () => import('@client/customs/catalogue/sjcopy/CreateFromSjField.jsx') },
  { field: 'Create from SJ', label: 'Create from SJ Catalogue', collapsible: true, load: () => import('@client/customs/catalogue/sjcopy/CreateFromSjField.jsx') },
  // BOM Generation (bom-generation/DESIGN.md): on the SJ's Epic, its own "BOM" tab — upload each section's BOM, the uploader
  // signs it, review what will be made, Create the Procurement Orders under 02 ORDERS; a later BOM adds only its new lines;
  // what the BOMs made, per section — bom-generation/BomGenerationField.jsx. The field's value is the line the last run wrote.
  { field: 'BOM Generation', label: 'BOM Generation', load: () => import('@client/customs/bom-generation/BomGenerationField.jsx') },
];
